/// <reference path="../../../../../rcwebmodels/reeferformatter.cs.d.ts" />
import * as React from 'react';
import * as ReactDom from 'react-dom';
import { AgGridReact } from 'ag-grid-react';
//import Bing from '../../actions/ReeferMap.js';
//import * as ReeferMapjs from '../../actions/ReeferMap.js';
//var Bing = ReeferMapjs.default;
import ReeferCallout from '../../actions/ReeferCallout';
import 'ag-grid-enterprise';
import Formatters from '../../actions/Formatters';
import ReeferFormatters from '../../actions/ReeferFormatter';
import { ReeferCellRenderer } from '../../actions/ReeferCellRenderer';
import $ from 'jquery';
import moment from 'moment';
import DateFormat from 'dateformat';
import { RCUtils } from './../../RCUtils';
import { GridReeferHistoryToolBar } from '../sharedcomponents/GridReeferHistoryToolBar';
import CCAlmTooltip from '../sharedcomponents/GridToolTips/CCAlmTooltip';
import { ReeferTemperatureGraph } from './ReeferTemperatureGraph';
//import { DateTime } from 'react-datetime-bootstrap';
import DatePicker from 'react-datepicker';
//import "../../../node_modules/bootstrap/dist/css/bootstrap.css";
// pull in the ag-grid styles we're interested in
import '../../../node_modules/ag-grid-community/dist/styles/ag-grid.css';
import '../../../node_modules/ag-grid-community/dist/styles/ag-theme-fresh.css';
import { PopupWindow } from '../sharedcomponents/PopupWindow';
import { ReeferStatusGrid } from './ReeferStatusGrid';
//import { GridPreferenceControl } from './../sharedcomponents/GridPreferenceControl';
import { GridColumnPreferences } from './../sharedcomponents/GridColumnPreferences';
import { ReeferMap } from '../childcomponents/ReeferMap';
import lodashfilter from 'lodash/filter';
var Config: any = require('../../Config.json');

interface ReeferHistoryGridState {
    loading: boolean;
    rowData: ReeferUnitHistoryUI[];
    Filters: ReeferHistoryFilter;
    columnDefs: any[];
    overlayLoadingTemplate: any;
    pageSize: any;
    gridApiParams: any;
    reeferFormatter: server.ReeferFormatter;
    buttonState: boolean;
    PreferenceDTTM: any;
    //buttonSearchHtml: any;
    defaultColDef: any[];
    rowGroupPanelShow: string;
    groupDefaultExpanded: number;
    autoGroupColumnDef: any;
    selectedDataItems: any[];
    frameworkComponents: any;
}
var self;
var functionId;
var columnDefs: any[];
var columnDefs2: any[];
var isMapEnable: boolean;
var reeferAssetSensors: any[];

export class ReeferHistoryGrid extends React.Component<any, ReeferHistoryGridState> {
    constructor(props: any) {
        super(props);
        var filterSet = this.initHistoryFilters();//new ReeferHistoryFilter();
        functionId = 42; // functionId for ReeferHistory Grid
        
        var overlayTemplate = '<span class="ag-overlay-loading-center">Loading...</span>';
        var currentUtcDttm = moment(new Date(new Date().toUTCString()).toISOString(), 'YYYY-MM-DDTHH:mm:ss');
        this.state = {
            loading: true,
            rowData: [],
            columnDefs: [],
            overlayLoadingTemplate: overlayTemplate,
            Filters: filterSet,
            pageSize: 25,
            gridApiParams: [],
            reeferFormatter: this.props.propsReeferFormatterData,
            buttonState: false,
            PreferenceDTTM: Formatters.DateTimeFormatter(currentUtcDttm),
            defaultColDef: [],
            rowGroupPanelShow: 'always',
            groupDefaultExpanded: -1,
            autoGroupColumnDef: { minWidth: 200 },
            selectedDataItems: [],
            frameworkComponents: { cCAlmTooltip: CCAlmTooltip},
        };

        //var columnDefs = this.createColumnDefs();
        self = this;
        //var filterParams = JSON.stringify(this.state.Filters);
        //if (this.state.reeferFormatter === null) {
        
        //    var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/common/GetReeferFormattersList', { method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        //    fetch(request)
        //        .then(RCUtils.handleError)
        //        .then(response => response.json() as Promise<server.ReeferFormatter>)
        //        .then(data => {
        //            this.setState({
        //                reeferFormatter: data
        //                //}, () => {
        //                //    var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferhistory/ReeferHistoryDataSP', { method: 'POST', body: filterParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        //                //    fetch(request)
        //                //        .then(RCUtils.handleError)
        //                //        .then(response => response.json() as Promise<ReeferUnitHistoryUI[]>)
        //                //        .then(data => {
        //                //            this.setState({
        //                //                rowData: data,
        //                //                loading: false
        //                //            });
        //                //        });
        //            });
        //        });
        //}
        //else {
        //    var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferhistory/ReeferHistoryDataSP', { method: 'POST', body: filterParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        //    fetch(request)
        //        .then(RCUtils.handleError)
        //        .then(response => response.json() as Promise<ReeferUnitHistoryUI[]>)
        //        .then(data => {
        //            this.setState({
        //                rowData: data,
        //                loading: false
        //            });
        //        });
        //}
    }

    initHistoryFilters() {
        var reeferHistoryFilter = new ReeferHistoryFilter();
        reeferHistoryFilter.Units = '';
        reeferHistoryFilter.FromDate = DateFormat(new Date(), 'mm/dd/yyyy HH:MM');
        reeferHistoryFilter.ToDate = DateFormat(new Date(), 'mm/dd/yyyy HH:MM');

        return reeferHistoryFilter;
    }

    renderCustomerDeviceTypeSensorColumns() {
        columnDefs = this.createColumnDefs();
        var newColumns = columnDefs;
        //columnDefs2 = columnDefs;
        var generatedColumns = [];

        if (this.props.customerDeviceTypeSensor != null && this.props.customerDeviceTypeSensor != undefined) 
            reeferAssetSensors = this.props.customerDeviceTypeSensor.filter(x => x.AssetTypeCd == 'R');

        if (reeferAssetSensors != null && reeferAssetSensors != undefined && reeferAssetSensors.length > 0) {
            $.each(reeferAssetSensors, function (i, val) {
                var customerDeviceTypeSensorObject: any;
                if (val.SensorTypeCd.trim() == "T")
                    customerDeviceTypeSensorObject = { headerName: '', field: '', headerClass: val.OORText, enableRowGroup: true, sortable: true, resizable: true, headerValueGetter: Formatters.TempSensorHeaderFormatter, valueGetter: Formatters.stringTypeSortingForSensorfields, cellRenderer: Formatters.TemperatureSensorValueFormatter, width: 130 };
                else
                    customerDeviceTypeSensorObject = { headerName: '', field: '', refData: val.SensorSetDsc + "," + val.SensorResetDsc, headerClass: val.OORText, enableRowGroup: true, sortable: true, resizable: true, valueGetter: Formatters.stringTypeSortingForDigitalSensorfields, cellRenderer: Formatters.DigitalSensorFormatter, width: 130 };

                //var fieldName = val.FieldValue;
                var columnHeaderName = val.ColumnNm;
                var columnFieldName = val.FieldName + "_" + val.DeviceTypeCd.trim();
                customerDeviceTypeSensorObject.headerName = columnHeaderName;
                customerDeviceTypeSensorObject.field = columnFieldName;
                generatedColumns.push(customerDeviceTypeSensorObject);
            });
            var newSensorColumnDefination = {
                headerName: "Device Sensor(s)",
                children: generatedColumns
            };
            if (!newColumns.some(x => x.headerName === "Device Sensor(s)"))
                newColumns.push(newSensorColumnDefination);
            this.setState({ columnDefs: newColumns });

            if (!columnDefs2.some(x => x.headerName === "Device Sensor(s)"))
                columnDefs2.push(newSensorColumnDefination);// = newColumns;
        }
        else {
            this.setState({ columnDefs: columnDefs });
        }
    }

    componentDidMount() {
        //var columnDefs = this.createColumnDefs();
        if (this.state.reeferFormatter === null) {
            var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/common/GetReeferFormattersList', { method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json() as Promise<server.ReeferFormatter>)
                .then(data => {
                    this.setState({
                        reeferFormatter: data
                        //}, () => {
                        //    var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferhistory/ReeferHistoryDataSP', { method: 'POST', body: filterParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
                        //    fetch(request)
                        //        .then(RCUtils.handleError)
                        //        .then(response => response.json() as Promise<ReeferUnitHistoryUI[]>)
                        //        .then(data => {
                        //            this.setState({
                        //                rowData: data,
                        //                loading: false
                        //            });
                        //        });
                    });
                });
        }
        columnDefs2 = this.createColumnDefs();
        //this.setState({ columnDefs: columnDefs });
        setTimeout(() => {
            this.renderCustomerDeviceTypeSensorColumns();
        }, 1000);
       
       
        
        

        this.renderDateFields();
        self.enableDisableSearchButton(false);
    }

    onGridReady(params: any) {
       // params.api.gridOptionsWrapper.gridOptions.suppressContextMenu = true;
        self.setState({ gridApiParams: params.api });
        var gridPreferencesData: any = self.props.dashboardWidgetsSearch.filter(x=>x.DashboardWidgetId == 5);
        var defaultColumns = params.api.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
        params.api.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultColumns, false);
        setTimeout(() => {
            GridColumnPreferences.HistoryGridPreferenceColumns(functionId, params.api, gridPreferencesData, "ReeferHistoryGrid");
        }, 3000);     
        //GridPreferenceControl.HistoryGridPreferenceColumns(functionId, params.api, "ReeferHistoryGrid");
    }
        
    static refreshGridReady(dashboardWidgetsSearch: any){
        var gridPreferencesData: any = dashboardWidgetsSearch.filter(x=>x.DashboardWidgetId == 5);
        var defaultColumns = self.state.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
        self.state.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultColumns, false);
        setTimeout(() => {
            GridColumnPreferences.HistoryGridPreferenceColumns(functionId, self.state.gridApiParams, gridPreferencesData, "ReeferHistoryGrid");
        }, 3000);       
    }

    //WI 26721
    static GetReeferHistoryGridPrefColumns(gridPreferencesData: any) {
        //var gridPreferencesData: any = self.props.dashboardWidgetsSearch.filter(x=>x.DashboardWidgetId == 5);
        GridColumnPreferences.HistoryGridPreferenceColumns(functionId, self.state.gridApiParams, gridPreferencesData, "ReeferHistoryGrid");
    }

    static refreshHistoryGrid(isFromCCAssignOrUnassign: boolean) { //RCNG-1172
        self.refreshGrid(isFromCCAssignOrUnassign);
    }

    refreshGrid = (isFromCCAssignOrUnassign:boolean) => {
        $('#globalLoader').show();
        var filterParams = JSON.stringify(this.state.Filters);
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferhistory/ReeferHistoryDataSP', { method: 'POST', body: filterParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<ReeferUnitHistoryUI[]>)
            .then(data => {
                isMapEnable = self.props.mapEnabled;
                if (data.length > 0 && isMapEnable) {
                    ReeferCallout.BindTracePushpins(data, 'trace');
                    var dataArray = [];
                    if (self.state.selectedDataItems != null && self.state.selectedDataItems != undefined && self.state.selectedDataItems.length > 0)
                        dataArray.push(self.state.selectedDataItems[0]);
                    else
                        dataArray.push(data[0]);
                    self.BindMapPushPin(dataArray);
                }
                this.updateGraphData(data);                
                this.setState({
                    rowData: data
                }, () => { if(!isFromCCAssignOrUnassign) $('#globalLoader').hide(); });
            });
    };

    updateGraphData(data) {
        ReeferTemperatureGraph.BindTemperatureGraphData(self.state.Filters, data);
    }

    static ApplyReeferHistorySearch(params: any, isFromMap: boolean, isHistoryEnabled: boolean) {
        $('#globalLoader').show();
        if (self != undefined && isHistoryEnabled) {
            isMapEnable = self.props.mapEnabled;
            if(self.state.gridApiParams!=null && self.state.gridApiParams!=undefined && self.state.gridApiParams.length > 0) //RCNG-207
            {
            self.state.gridApiParams.showLoadingOverlay();
            }
            self.setState({ loading: true });
            self.enableDisableSearchButton(true);           
            if (params.EventDTTM != null && params.EventDTTM != "") {
                var currentUtcDttm = moment(new Date(new Date().toUTCString()).toISOString(), 'YYYY-MM-DDTHH:mm:ss');
                var currenttoDTTM = Formatters.DateTimeFormatter(currentUtcDttm);
                var toDTTM = Formatters.DateTimeFormatter(params.EventDTTM);
                var modifiedDttm = new Date(toDTTM);
                modifiedDttm.setDate(modifiedDttm.getDate() - 1);
                var fromDTTM = DateFormat(new Date(modifiedDttm.toString()), 'mm/dd/yyyy');
                var fromDate = moment(new Date(fromDTTM)).startOf('day').toString();
                var toDate = moment(new Date(currenttoDTTM)).endOf('day').toString();
                self.state.Filters.FromDate = DateFormat(new Date(fromDate), 'mm/dd/yyyy HH:MM');
                self.state.Filters.ToDate = DateFormat(new Date(toDate), 'mm/dd/yyyy HH:MM');
            }
            else {
                var currentUtcDttm = moment(new Date(new Date().toUTCString()).toISOString(), 'YYYY-MM-DDTHH:mm:ss');
                var toDTTM = Formatters.DateTimeFormatter(currentUtcDttm);
                var modifiedDttm = new Date(toDTTM);
                modifiedDttm.setDate(modifiedDttm.getDate() - 1);
                var fromDTTM = DateFormat(new Date(modifiedDttm.toString()), 'mm/dd/yyyy');
                var fromDate = moment(new Date(fromDTTM)).startOf('day').toString();
                var toDate = moment(new Date(toDTTM)).endOf('day').toString();
                self.state.Filters.FromDate = DateFormat(new Date(fromDate), 'mm/dd/yyyy HH:MM');
                self.state.Filters.ToDate = DateFormat(new Date(toDate), 'mm/dd/yyyy HH:MM');
            }

            self.state.Filters.Units = params.UnitMasterID;

            var filterParams = JSON.stringify(self.state.Filters);            
            if (self.state.reeferFormatter === null) {
                var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/common/GetReeferFormattersList', { method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
                fetch(request)
                    .then(RCUtils.handleError)
                    .then(response => response.json() as Promise<server.ReeferFormatter>)
                    .then(data => {
                        self.setState({
                            reeferFormatter: data
                        }, () => {
                            var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferhistory/ReeferHistoryDataSP', { method: 'POST', body: filterParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
                            fetch(request)
                                .then(RCUtils.handleError)
                                .then(response => response.json() as Promise<ReeferUnitHistoryUI[]>)
                                .then(data => {
                                    self.state.gridApiParams.hideOverlay();
                                    self.setState({
                                        rowData: data,
                                        loading: false
                                    });

                                    self.updateGraphData(data);

                                    if (data.length > 0 && isMapEnable) {
                                        ReeferStatusGrid.validateReeferStatusHistoryMismatch(params.EventDTTM, data[0].EventDTTM, params.ModifiedDTTM, data[0].ModifiedDTTM);//RCNG-1045
                                        ReeferCallout.BindTracePushpins(data, 'trace');
                                        var dataArray = [];
                                        if (self.state.selectedDataItems != null && self.state.selectedDataItems != undefined && self.state.selectedDataItems.length > 0)
                                            dataArray.push(self.state.selectedDataItems[0]);
                                        else
                                            dataArray.push(data[0]);
                                        self.BindMapPushPin(dataArray);
                                    }
                                    else
                                        $('#globalLoader').hide();

                                    self.props.reeferIdForHeader(params.ReeferID);
                                    if (isFromMap)
                                        ReeferStatusGrid.SelectCurrentNode(params.ReeferID);
                                });
                        });
                    });
            }
            else {
                var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferhistory/ReeferHistoryDataSP', { method: 'POST', body: filterParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
                fetch(request)
                    .then(RCUtils.handleError)
                    .then(response => response.json() as Promise<ReeferUnitHistoryUI[]>)
                    .then(data => {
                        self.state.gridApiParams.hideOverlay();
                        self.setState({
                            rowData: data,
                            loading: false
                        });

                        self.updateGraphData(data);

                        if (data.length > 0 && isMapEnable) {
                            ReeferStatusGrid.validateReeferStatusHistoryMismatch(params.EventDTTM, data[0].EventDTTM, params.ModifiedDTTM, data[0].ModifiedDTTM); //RCNG-1045
                            ReeferCallout.BindTracePushpins(data, 'trace');
                            var dataArray = [];
                            if (self.state.selectedDataItems != null && self.state.selectedDataItems != undefined && self.state.selectedDataItems.length > 0)
                                dataArray.push(self.state.selectedDataItems[0]);
                            else
                                dataArray.push(data[0]);                           
                            self.BindMapPushPin(dataArray);
                        }
                        else
                            $('#globalLoader').hide();

                        self.props.reeferIdForHeader(params.ReeferID);
                        if (isFromMap)
                            ReeferStatusGrid.SelectCurrentNode(params.ReeferID);
                    });
            }
        }
        else {
            $('#globalLoader').hide();
        }
    }

    static ClearHistoryGridData() {
        if (self != undefined) {
            self.setState({
                rowData: [],
                loading: false
            });

            self.enableDisableSearchButton(false);
            ReeferTemperatureGraph.ClearGraphData();
        }
    }

    static refreshDataGrid() {
        self.setState({
            rowData: self.state.rowData
        });
    };

    enableDisableSearchButton(isEnable: any) {
        if (isEnable) {
            this.setState({ buttonState: true });
        }
        else {
            this.setState({ buttonState: false });
        }
    }   
    toolTipValueGetter = (params) => ({ value: params.value });
    copyToClipboard(text) {
        if ((window as any).clipboardData && (window as any).clipboardData.setData) {
            return (window as any).clipboardData.setData("Text", text);
        } else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
            var textarea = document.createElement("textarea");
            textarea.textContent = text;
            textarea.style.position = "fixed";
            document.body.appendChild(textarea);
            textarea.select();
            try {
                return document.execCommand("copy");
            } catch (ex) {
                return false;
            } finally {
                document.body.removeChild(textarea);
            }
        }
    }   

    ProcessCellForClipboard(params) {
        return Formatters.CopyCommandFormatters(params);
    }

    copyRowsToClipBoard() {        
        self.state.gridApiParams.gridOptionsWrapper.gridOptions.api.copySelectedRowsToClipboard({ includeHeaders: false });//RCNG-225
    }

    copyRowsWithHeadersToClipBoard() {        
        self.state.gridApiParams.gridOptionsWrapper.gridOptions.api.copySelectedRowsToClipboard({ includeHeaders: true });//RCNG-225
    }

    getReeferHistoryContextMenuItems = params => {
        if (params != null && params != undefined && params.node != null && params.node != undefined && !params.node.group) {
            var selectflag = false;
            var selectedCell = params.api.getFocusedCell();
            var selectedRowIndex = selectedCell.rowIndex;
            var currentRow = params.api.getDisplayedRowAtIndex(selectedRowIndex);
            if (currentRow != null && currentRow != "undefined" && !currentRow.group) {
                var currentRowId = currentRow.id;
             //   coppiedData = params.value;
                var selectedrowNode = params.api.getRowNode(currentRowId);
                var parentEventID = selectedrowNode.data.ParentEventID;
                params.api.forEachLeafNode((newRowNode, index) => {
                    if ((newRowNode.data.ParentEventID === parentEventID)) {
                        selectedrowNode = newRowNode;
                        return false;
                    }
                });
                $.each(self.state.selectedItems, (index, item) => {
                    if (item.ParentEventID == selectedrowNode.data.ParentEventID) {
                        selectflag = true;
                        return false;
                    }
                });
                if (!selectflag)
                    params.api.deselectAll();
                selectedrowNode.setSelected(true);
            }
            var result = [
                {
                    name: 'Copy',
                    subMenu: [
                        {
                            name: 'Copy Cell',
                            action: () => {
                                //this.reeferContextMenuClick("Copy");
                                var cellContent = this.ProcessCellForClipboard(params);
                                params.api.clipboardService.copyDataToClipboard(cellContent);

                            }
                        },
                        {
                            name: 'Copy Row(s)',
                            action: () => {
                                this.copyRowsToClipBoard();
                            }
                        },
                        {
                            name: 'Copy Row(s) with Headers',
                            action: () => {
                                this.copyRowsWithHeadersToClipBoard();
                            }
                        },
                    ],
                },
            ];
            return result;
        }
    };

    createColumnDefs() {
        return [
            {
                headerName: 'Group',
                minWidth: 210,
                hide: true
            },
            {
                headerName: 'State Indicators History',
                children: [
                    {
                        headerName: "CC", field: "CCSeverityLevel", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, width: 65, filterParams: { valueGetter: params => { return ReeferFormatters.CargoCareFormatterForFilter(params); } }, valueGetter: (params) => { return ReeferFormatters.CargoCareSorting(params); }, cellRenderer: ReeferCellRenderer.CargoCareFormatter, tooltipComponent: 'cCAlmTooltip',
                        tooltipValueGetter: this.toolTipValueGetter, cellRendererParams: { almData: self.state.reeferFormatter.AlarmMasterList }
                    },
                    { headerName: "ALM", field: "MASeverityLevel", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, width: 65, filterParams: { valueGetter: params => { return ReeferFormatters.statusIndicatorWithDescriptionForALMForFilter(params); } }, valueGetter: (params) => { return ReeferFormatters.statusALMSorting(params); }, cellRenderer: (params) => { return ReeferCellRenderer.StatusIndicatorWithDescriptionForAlarms(params, self.state.reeferFormatter.AlarmMasterList) } },
                    { headerName: "RUN", field: "RunState", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, width: 65, filterParams: { valueGetter: params => { return ReeferFormatters.runStateFormatterForFilter(params); } }, valueGetter: (params) => { return ReeferFormatters.RunstateSorting(params); }, cellRenderer: ReeferCellRenderer.RunStateFormatter },
                    { headerName: "PWR", field: "DevicePowerSourceCd", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, width: 65, filterParams: { valueGetter: params => { return Formatters.pwrStateFormatterForFilter(params); } }, valueGetter: (params) => { return Formatters.PwrSorting(params); }, cellRenderer: ReeferCellRenderer.PwrStateFormatter },
                    { headerName: "BATT", field: "ReeferBatteryPct", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, filterParams: { valueGetter: params => { return Formatters.reeferBatteryPctFormatterFilter(params); } }, resizable: true, width: 65, valueGetter: (params) => { return Formatters.reeferBatteryPctSorting(params); }, cellRenderer: ReeferCellRenderer.BatteryPctFormatter },
                    { headerName: "VSL", field: "VesselCd", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, width: 80, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "VesselCd"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter },
                    { headerName: "VVC Dep", field: "DepartingVVC", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.DepartingVVCstringTypeValueFormatter(params); }, width: 100 },
                    { headerName: "VVC Arr", field: "ArrivingVVC", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.ArrivingVVCstringTypeValueFormatter(params); }, width: 100 },
                    { headerName: "TRIP", field: "TripStatusCdAndDFlag", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, tooltipField: "TripNameAndStatus", valueGetter: (params) => { return ReeferFormatters.TripSorting(params); }, cellRenderer: ReeferCellRenderer.TripstatusIndicator, width: 70 },
                    { headerName: "INV", field: "AssetState", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, width: 80, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "AssetState"); }, cellRenderer: ReeferCellRenderer.AssetStateFormatter }
                ]
            },
            {
                headerName: 'Identification History',
                children: [
                    {
                        headerName: "OEM", field: "ReeferOEMTypeCd", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                        filterParams: { valueGetter: params => { return ReeferFormatters.oemTypeFormatterForFilter(params); } }, valueGetter: params => { return ReeferFormatters.OEMTypeValueFormatterFieldName(params); }, width: 70
                    },
                    {
                        headerName: "Reefer ID", field: "ReeferID", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "ReeferID"); },
                        cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 140
                    },
                    {
                        headerName: "Model", field: "OEMModel", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "OEMModel"); },
                        cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 130
                    },
                ]
            },
            {
                headerName: "Booking History",
                children: [
                    { headerName: "Booking #", field: "BookingNumber", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "BookingNumber"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 130 },
                    { headerName: "BK temp ", headerValueGetter: Formatters.TempHeaderFormatter, enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "TemperatureUnit"); }, cellRenderer: ReeferFormatters.TemperatureFormatterForBooking, field: "TemperatureUnit", width: 130 },
                    { headerName: "CC profile", field: "CCProfileCode", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "CCProfileCode"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 140 },
                    { headerName: "CC alerts", field: "CCAlarms", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.CCAlarmAliasDescriptionSorting(params, self.state.reeferFormatter.AlarmMasterList); }, cellRenderer: (params) => { return ReeferCellRenderer.CCAlertAlarmAliasDescriptionFormatter(params, self.state.reeferFormatter.AlarmMasterList) }, tooltipComponent: 'cCAlmTooltip', tooltipValueGetter: this.toolTipValueGetter, cellRendererParams: { almData: self.state.reeferFormatter.AlarmMasterList },  width: 150 },
                    { headerName: "BK VV", field: "BKVV", enableRowGroup: true, columnGroupShow: 'open', cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.BKVVstringTypeValueFormatter(params); }, width: 100 },
                    { headerName: "BK POR", field: "BKPOR", enableRowGroup: true, columnGroupShow: 'open', cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "BKPOR"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 140 },
                    { headerName: "BK POL", field: "BKPOL", enableRowGroup: true, columnGroupShow: 'open', cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "BKPOL"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 140 },
                    { headerName: "BK POD", field: "BKPOD", enableRowGroup: true, columnGroupShow: 'open', cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "BKPOD"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 140 },
                    { headerName: "BK DEL", field: "BKDEL", enableRowGroup: true, columnGroupShow: 'open', cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "BKDEL"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 140 },
                    { headerName: "BK Customer", field: "BKCustomer", enableRowGroup: true, columnGroupShow: 'open', cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "BKCustomer"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 140 },
                    { headerName: "Trip Start", enableRowGroup: true, columnGroupShow: 'open', cellClass: 'myExcelStyle', sortable: true, filter: true, filterParams: { valueGetter: params => { return Formatters.dateTypeFormatterTripStartForFilter(params); } }, resizable: true, headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "TripStart", valueGetter: (params) => { return Formatters.dateTypeSortingFieldName(params, "TripStart"); }, cellRenderer: Formatters.dateTypeFormatter, width: 150 },
                    { headerName: "Trip End ", enableRowGroup: true, columnGroupShow: 'open', cellClass: 'myExcelStyle', sortable: true, filter: true, filterParams: { valueGetter: params => { return Formatters.dateTypeFormatterTripEndForFilter(params); } }, resizable: true, headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "TripEnd", valueGetter: (params) => { return Formatters.dateTypeSortingFieldName(params, "TripEnd"); }, cellRenderer: Formatters.dateTypeFormatter, width: 150 },
                ]
            },
            {
                headerName: 'Event and Location History',
                children: [
                    { headerName: "Event", field: "EventDescription", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, width: 150, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "EventDescription"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter },
                    { headerName: "Event time", headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "EventDTTM", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, filterParams: { valueGetter: params => { return Formatters.dateTypeFormatterEventDTTMForFilter(params); } }, valueGetter: (params) => { return Formatters.dateTypeSortingFieldName(params, "EventDTTM"); }, cellRenderer: Formatters.dateTypeFormatter, width: 170 },
                    { headerName: "Event notes", field: "EventNotes", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "EventNotes"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 150 },
                    {
                        headerName: "Door", field: "DoorOpen", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, getQuickFilterText: ReeferFormatters.doorQuickFilterFormatter,
                        filterParams: { valueGetter: params => { return ReeferFormatters.doorFormatterFilter(params); } },
                        valueGetter: (params) => { return ReeferFormatters.DoorFormatterSorting(params); }, cellRenderer: ReeferFormatters.doorFormatter, width: 140
                    },
                    { headerName: "Door time", headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "DoorEventDtm", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, filterParams: { valueGetter: params => { return Formatters.dateTypeFormatterDoorEventDtmForFilter(params); } }, valueGetter: (params) => { return Formatters.dateTypeSortingFieldName(params, "DoorEventDtm"); }, cellRenderer: Formatters.dateTypeFormatter, width: 170 },
                    { headerName: "Device fence", field: "GeofenceName", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "GeofenceName"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 150 },
                    { headerName: "Server fence", field: "ServerGeofenceName", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "ServerGeofenceName"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 150 },
                    //{ headerName: "Region Fence", field: "RegionGeofenceName", cellRenderer: Formatters.stringTypeFormatter, width: 150 },
                    { headerName: "Device fence ID", field: "Geofence", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "Geofence"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 130 },
                    { headerName: "Server fence ID", field: "ServerGeofence", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "ServerGeofence"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 150 },
                    { headerName: "Loc coords", field: "GPSCoords", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.GPSCoordsSorting(params); }, filterParams: { valueGetter: params => { return Formatters.GPSCoordsForFilter(params); } }, cellRenderer: ReeferCellRenderer.GPSCoordsFormatter, width: 150 },
                    { headerName: "Loc age (h:m:s)", field: "GPSLastLock", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.reeferSecondsToTimeConverterFilter(params); }, width: 150 },
                    { headerName: "City", field: "City", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "City"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 140 },
                    { headerName: "State", field: "State", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "State"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 140 },
                    { headerName: "Country", field: "Country", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "Country"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 150 },
                    { headerName: "Zip", field: "Zip", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "Zip"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 100 },
                    { headerName: "Receipt time", headerValueGetter: Formatters.TimeZoneHeaderFormatter, enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, field: "ModifiedDTTM", filterParams: { valueGetter: params => { return Formatters.dateTypeFormatterModifiedDTTMForFilter(params); } }, valueGetter: (params) => { return Formatters.dateTypeSortingFieldName(params, "ModifiedDTTM"); }, cellRenderer: Formatters.dateTypeFormatter, width: 150 },
                ]
            },
            {
                headerName: 'Reefer Datalog Events History',
                children: [
                    { headerName: "DL event", field: "DLEventMasterID", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, width: 150, valueGetter: (params) => { return ReeferFormatters.DLEventDescriptionFormatters(params, self.state.reeferFormatter.CustomerSpecificEventList, self.state.reeferFormatter.EventMasterList); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter },
                    { headerName: "DL event time", headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "DLEventDTTM", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, filterParams: { valueGetter: params => { return Formatters.dateTypeFormatterDLEventDTTMForFilter(params); } }, valueGetter: (params) => { return Formatters.dateTypeSortingFieldName(params, "DLEventDTTM"); }, cellRenderer: Formatters.dateTypeFormatter, width: 170 },
                    { headerName: "Data 1", field: "DLParam1", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "DLParam1"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 110 },
                    { headerName: "Data 2", field: "DLParam2", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "DLParam2"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 110 },
                    { headerName: "Data 3", field: "DLParam3", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "DLParam3"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 110 },
                    { headerName: "Data 4", field: "DLParam4", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "DLParam4"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 110 },
                    { headerName: "Data 5", field: "DLParam5", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "DLParam5"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 110 }
                ]
            },
            {
                headerName: 'Reefer Status History',
                children: [
                    { headerName: "Alarm", field: "AlarmsList", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.AlarmDescriptionSorting(params, self.state.reeferFormatter.AlarmMasterList); }, cellRenderer: (params) => { return ReeferCellRenderer.AlarmsDescriptionFormatter(params, self.state.reeferFormatter.AlarmMasterList) }, width: 150 },
                    { headerName: "Opr mode", field: "RunningMode", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.OperatingModeFormatter(params); }, width: 150 },
                    { headerName: "Reefer data", headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "UnitEventDTTM", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, filterParams: { valueGetter: params => { return Formatters.dateTypeFormatterUnitEventDTTMForFilter(params); } }, valueGetter: (params) => { return Formatters.dateTypeSortingFieldName(params, "UnitEventDTTM"); }, cellRenderer: Formatters.dateTypeFormatter, width: 150 },
                    { headerName: "T set ", headerValueGetter: Formatters.TempHeaderFormatter, enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "SetPoint"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "SetPoint", width: 90 },
                    { headerName: "T sup 1 ", headerValueGetter: Formatters.TempHeaderFormatter, enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "SupplyTemp1"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "SupplyTemp1", width: 90 },
                    { headerName: "T sup 2 ", headerValueGetter: Formatters.TempHeaderFormatter, enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "SupplyTemp2"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "SupplyTemp2", width: 90 },
                    { headerName: "T rtn 1 ", headerValueGetter: Formatters.TempHeaderFormatter, enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "ReturnTemp1"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "ReturnTemp1", width: 90 },
                    { headerName: "T rtn 2 ", headerValueGetter: Formatters.TempHeaderFormatter, enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "ReturnTemp2"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "ReturnTemp2", width: 90 },
                    { headerName: "T amb ", headerValueGetter: Formatters.TempHeaderFormatter, enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "AmbientTemp"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "AmbientTemp", width: 90 },
                    { headerName: "RH set", field: "HumiditySetpoint", enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "HumiditySetpoint"); }, cellRenderer: ReeferFormatters.HumiditySetpointFormatter, width: 90 },
                    { headerName: "RH read", field: "Humidity", enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.HumiditySettingFormatter(params); }, width: 90 },
                    { headerName: "CO2 set", field: "CO2Setpoint", enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "CO2Setpoint"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatter, width: 90 },
                    { headerName: "CO2 read", field: "CO2Reading", enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "CO2Reading"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatter, width: 90 },
                    { headerName: "O2 set", field: "O2Setpoint", enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "O2Setpoint"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatter, width: 90 },
                    { headerName: "O2 read", field: "O2Reading", enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "O2Reading"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatter, width: 90 },
                    { headerName: "T evap in ", enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, headerValueGetter: Formatters.TempHeaderFormatter, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "EvaporatorInletSensor"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "EvaporatorInletSensor", width: 110 },
                    { headerName: "T evap out ", enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, headerValueGetter: Formatters.TempHeaderFormatter, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "EvaporatorOutletSensor"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "EvaporatorOutletSensor", width: 110 },
                    { headerName: "P suc", field: "CompositeSuctionPressure", enableRowGroup: true, cellClass: 'TwoDecimal', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "CompositeSuctionPressure"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatterTwoDecimal, width: 90 },
                    { headerName: "T suc ", headerValueGetter: Formatters.TempHeaderFormatter, enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "CompressorSuctionTemp"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "CompressorSuctionTemp", width: 90 },
                    { headerName: "P dis", field: "DischargePressure", enableRowGroup: true, cellClass: 'TwoDecimal', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "DischargePressure"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatterTwoDecimal, width: 90 },
                    { headerName: "T dis ", headerValueGetter: Formatters.TempHeaderFormatter, enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "CompressorDischargeTemp"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "CompressorDischargeTemp", width: 90 },
                    { headerName: "T dis 2 ", enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, headerValueGetter: Formatters.TempHeaderFormatter, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "CompressorDischargeTemp2"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "CompressorDischargeTemp2", width: 90 },
                    { headerName: "T econ in ", enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, headerValueGetter: Formatters.TempHeaderFormatter, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "EconomizerInTemp"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "EconomizerInTemp", width: 90, columnGroupShow: 'open' },
                    { headerName: "T econ out ", enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, headerValueGetter: Formatters.TempHeaderFormatter, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "EconomizerOutTemp"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "EconomizerOutTemp", width: 90, columnGroupShow: 'open' },
                    { headerName: "P cond", field: "CondenserPressure", enableRowGroup: true, cellClass: 'TwoDecimal', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataPCondFormatter(params); }, cellRenderer: ReeferFormatters.sensorDataValueFormatterTwoDecimal, width: 90 },
                    { headerName: "T cond wall ", headerValueGetter: Formatters.TempHeaderFormatter, enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "CondenserTemperature"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "CondenserTemperature", width: 110 },
                    { headerName: "M cond", field: "CondenserFanOutPut", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "CondenserFanOutPut"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatter, width: 90 },
                    { headerName: "Evap fan set", field: "EvaporatorFanSpeedControl", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "EvaporatorFanSpeedControl"); }, columnGroupShow: 'open', cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 140 },
                    { headerName: "LS evap", field: "LowSpeedEvaporatorFanOutPut", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "LowSpeedEvaporatorFanOutPut"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatter, width: 90 },
                    { headerName: "HS evap", field: "HighSpeedEvaporatorFanOutPut", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "HighSpeedEvaporatorFanOutPut"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatter, width: 90 },
                    { headerName: "Air pump hr", field: "AirPumpRunHours", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, valueGetter: (params) => { return Formatters.AirPumpRunHoursSorting(params); }, cellRenderer: ReeferFormatters.AirPumpRunHoursFormatter, width: 120, columnGroupShow: 'open' },
                    { headerName: "Heat on", field: "HeaterOnTime", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "HeaterOnTime"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatter, width: 90 },
                    { headerName: "Open exp", field: "EvaporatorExpansionValveOpening", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataOpenExpFormatter(params); }, width: 90 },
                    { headerName: "Open suc", field: "SuctionModulationValveOpening", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataOpenSucFormatter(params); }, width: 90 },
                    { headerName: "Open dis", field: "HotGasValveOpening", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "HotGasValveOpening"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatter, width: 90 },
                    { headerName: "Open econ", field: "EconomizerValveOpening", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "EconomizerValveOpening"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatter, width: 90 },
                    { headerName: "Comp freq", field: "CompressorFrequency", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "CompressorFrequency"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatter, width: 90 },
                    { headerName: "Comp curr", field: "CompressorCurrent", enableRowGroup: true, cellClass: 'TwoDecimal', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "CompressorCurrent"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatter, width: 90 },
                    { headerName: "Comp hr", field: "CompressorRunHours", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, valueGetter: (params) => { return Formatters.CompressorRunHoursSorting(params); }, cellRenderer: ReeferFormatters.CompressorRunHoursFormatter, width: 120 },
                    { headerName: "CT state", field: "ColdTreatmentState", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "ColdTreatmentState"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 140 },
                    { headerName: "CT dur (d)", field: "CTDuration", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, valueGetter: (params) => { return Formatters.CTDurationSorting(params); }, cellRenderer: ReeferFormatters.CTDurationFormatter, width: 90 }, // RCNG-1819
                    { headerName: "CT max ", enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, headerValueGetter: Formatters.TempHeaderFormatter, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "CTTempLimit"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "CTTempLimit", width: 100 },//RCNG-1819
                    { headerName: "CT final ", enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, headerValueGetter: Formatters.TempHeaderFormatter, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "CTPostSetPoint"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "CTPostSetPoint", width: 100 },//RCNG-1819
                    { headerName: "CT rem (hr)", field: "CTRemainingTime", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, valueGetter: (params) => { return Formatters.CTRemainingTimeSorting(params); }, cellRenderer: ReeferFormatters.CTRemainingTimeFormatter, width: 120 }, // RCNG-1819
                    { headerName: "CT Time", cellClass: 'myExcelStyle', enableRowGroup: true, sortable: true, resizable: true, filterParams: { valueGetter: params => { return Formatters.dateTypeFormatterCTTimeForFilter(params); } }, headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "CTTime", valueGetter: (params) => { return Formatters.dateTypeSortingFieldName(params, "CTTime"); }, cellRenderer: Formatters.dateTypeFormatter, width: 120},
                    { headerName: "USDA 1 ", headerValueGetter: Formatters.TempHeaderFormatter, enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "USDA1Temp"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "USDA1Temp", width: 90 },
                    { headerName: "USDA 2 ", headerValueGetter: Formatters.TempHeaderFormatter, enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "USDA2Temp"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "USDA2Temp", width: 90 },
                    { headerName: "USDA 3 ", headerValueGetter: Formatters.TempHeaderFormatter, enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "USDA3Temp"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "USDA3Temp", width: 90 },
                    { headerName: "USDA4 cargo ", headerValueGetter: Formatters.TempHeaderFormatter, enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "Cargo4Temp"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "Cargo4Temp", width: 130 },
                    { headerName: "Vent pos", field: "VentPositionSensorCMH", enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "VentPositionSensorCMH"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatter, width: 90 },
                    { headerName: "CA mode", field: "ControlledAtmosphereMode", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.ControlledAtmosphereMode(params); }, width: 150 },
                    { headerName: "Bulb mode", field: "BulbMode", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "BulbMode"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 140 },
                    { headerName: "CA hr", field: "CARunHours", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, valueGetter: (params) => { return Formatters.CARunHoursSorting(params); }, cellRenderer: ReeferFormatters.CARunHoursFormatter, width: 120, columnGroupShow: 'open' },
                    { headerName: "CA SW ver", field: "CASoftwareRevision", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, valueGetter: (params) => { return Formatters.CASWVerSorting(params); }, cellRenderer: ReeferFormatters.CASWVerFormatter, width: 120, columnGroupShow: 'open' },
                    { headerName: "3 ph curr", field: "ThreePhaseCurrent", enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.ThreePhaseCurrentSortingFieldName(params, "ThreePhaseCurrent"); }, cellRenderer: ReeferFormatters.Current3PhaseFormatter, width: 135 },
                    { headerName: "Tot curr", field: "TotalCurrentDraw", enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "TotalCurrentDraw"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatter, width: 100 },
                    { headerName: "L1 (VAC)", field: "LineVoltage1", enableRowGroup: true, cellClass: 'TwoDecimal', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "LineVoltage1"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatterTwoDecimal, width: 90 },
                    { headerName: "L2 (VAC)", field: "LineVoltage2", enableRowGroup: true, cellClass: 'TwoDecimal', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "LineVoltage2"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatterTwoDecimal, width: 90 },
                    { headerName: "L3 (VAC)", field: "LineVoltage3", enableRowGroup: true, cellClass: 'TwoDecimal', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "LineVoltage3"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatterTwoDecimal, width: 90 },
                    {
                        headerName: "EverFRESH", field: "EverFRESH", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, getQuickFilterText: ReeferFormatters.everFreshQuickFilterFormatter,
                        filterParams: { valueGetter: params => { return ReeferFormatters.everFreshFormatterFilter(params); } },
                        valueGetter: (params) => { return ReeferFormatters.everFreshFormatterSorting(params); }, cellRenderer: ReeferFormatters.everFreshFormatter, width: 120
                    },
                    { headerName: "VFD", field: "VFD", enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "VFD"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatter, width: 90 },
                    { headerName: "OEM PTI state", field: "TripWiseStatusDescription", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.TripWiseStatusSorting(params, self.state.reeferFormatter.TripWiseStatusList); }, cellRenderer: (params) => { return ReeferCellRenderer.TripWiseStatusFormatter(params, self.state.reeferFormatter.TripWiseStatusList); }, width: 90 },
                    { headerName: "OEM PTI exp (d)", field: "TripWiseExpiration", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, valueGetter: (params) => { return Formatters.TripWiseExpirationSorting(params); }, cellRenderer: ReeferFormatters.TripWiseExpirationFormatter, width: 90 }, // RCNG-169
                    { headerName: "OEM PTI term start", field: "DimiStartAfter", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, width: 80, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "DimiStartAfter"); }, cellRenderer: ReeferCellRenderer.OEMPTITypeFormatter },
                    { headerName: "OEM PTI term (d)", field: "DimiTerm", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.DimiTermSorting(params); }, cellRenderer: ReeferFormatters.DimiRemainTermFormatter, width: 130 },
                    { headerName: "OEM PTI term rem (d)", field: "DimiRemainTerm", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.DimiRemainTermSorting(params); }, cellRenderer: ReeferFormatters.DimiRemainTermFormatter, width: 130 },
                    
                    { headerName: "PTI state", field: "PTIState", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "PTIState"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 130 },
                    { headerName: "PTI result", field: "PTResult", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, tooltip: Formatters.toolTipFormatter, valueGetter: (params) => { return ReeferFormatters.PTResultSorting(params); }, cellRenderer: ReeferCellRenderer.PreTripFormatter, width: 130 },
                    { headerName: "PTI Type", field: "PTIType", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "PTIType"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 120 },
                    { headerName: "PTI time", headerValueGetter: Formatters.TimeZoneHeaderFormatter, enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, field: "PTRDateTime", valueGetter: (params) => { return Formatters.dateTypeSortingFieldName(params, "PTRDateTime"); }, cellRenderer: Formatters.dateTypeFormatter, width: 150 },
                    { headerName: "Freq", field: "LineFrequency", enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.LineFrequencySorting(params); }, width: 130 },
                    { headerName: "Cont s/n", field: "ControllerSerialNumber", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "ControllerSerialNumber"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 150 },
                    { headerName: "Cont time", headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "DataLoggerDtm", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, valueGetter: (params) => { return Formatters.dateTypeSortingFieldName(params, "DataLoggerDtm"); }, cellRenderer: Formatters.dateTypeFormatter, width: 120 },
                    { headerName: "Cont SW version", field: "SoftwareRevision", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "SoftwareRevision"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 120 },
                    { headerName: "Cont set", field: "ControllerTypeSetting", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "ControllerTypeSetting"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 90 },

                    //{ headerName: "RFR Comms", field: "RCDRfrComErr", cellRenderer: Formatters.reeferCommsFormatter, width: 130 },
                    { headerName: "Fresh air type", field: "FreshAirType", enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "FreshAirType"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 120 },
                    { headerName: "Defrost int", field: "DefrostInterval", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "DefrostInterval"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 130, columnGroupShow: 'open' },
                    { headerName: "Tot pwr kWh", field: "PowerMeter", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.PowerMeterSorting(params); }, cellRenderer: ReeferFormatters.PowerMeterFormatter, width: 130 },
                ]
            },
            {
                headerName: 'Device Status History',
                children: [

                    { headerName: "Device ID", field: "RCDID", enableRowGroup: true, sortable: true, filter: true, resizable: true, cellClass: 'bigInt', valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "RCDID"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 150 },
                    { headerName: "Device supply (V)", field: "ReeferACPowerLevel", enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "ReeferACPowerLevel"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatter, width: 120 },
                    { headerName: "Device FW ver", field: "RCDFirmwareVersion", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.rcdFirmwareFormatter(params); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 130 },
                    { headerName: "Device BL ver", field: "RCDBootloaderVersion", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "RCDBootloaderVersion"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 130 },
                    { headerName: "Device mesh FW ver", field: "RCDMeshFirmwareVersion", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "RCDMeshFirmwareVersion"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 150 },
                    { headerName: "Device temp ", headerValueGetter: Formatters.TempHeaderFormatter, enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "DeviceTemp"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "DeviceTemp", width: 130 },
                    {
                        headerName: "Device bat (V)", field: "BatteryVoltage", enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, filter: true, resizable: true,
                        valueGetter: (params) => { return Formatters.BattVoltageSortingFieldName(params, "BatteryVoltage"); },
                        filterParams: { valueGetter: params => { return Formatters.BatteryVoltageFormatterForFilter(params); } },
                        cellRenderer: Formatters.BattVoltageValueFormatter, width: 130
                    },
                    {
                        headerName: "Door bat (V)", field: "DoorSensorBatteryVoltage", enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, filter: true, resizable: true,
                        valueGetter: (params) => { return Formatters.DoorBattVoltageSortingFieldName(params, "DoorSensorBatteryVoltage"); },
                        filterParams: { valueGetter: params => { return Formatters.DoorBatteryVoltageFormatterForFilter(params); } },
                        cellRenderer: Formatters.BattVoltageValueFormatter, width: 130
                    },
                    { headerName: "Reporting (min)", field: "RCDReportingInterval", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "RCDReportingInterval"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 130 },
                    { headerName: "Geofence revision", field: "RevisionNum", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "RevisionNum"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 150 },
                    { headerName: "MSISDN", field: "MSISDN", enableRowGroup: true, sortable: true, filter: true, resizable: true, cellClass: 'bigInt', valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "MSISDN"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 140 },
                    { headerName: "IMSI", field: "SIM_IMSI", enableRowGroup: true, sortable: true, filter: true, resizable: true, cellClass: 'bigInt', valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "SIM_IMSI"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 150 },
                    { headerName: "ICCID", field: "ICCID", enableRowGroup: true, sortable: true, filter: true, resizable: true, cellClass: 'bigInt', valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "ICCID"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 150 },
                    { headerName: "EUI", field: "EUI", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "EUI"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 150 },
                    { headerName: "MCC (country)", field: "CountryName", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "CountryName"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 150 },
                    { headerName: "MNC", field: "MNC", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.MNCSorting(params); }, cellRenderer: ReeferCellRenderer.MNCTypeFormatter, width: 70 },
                    { headerName: "LAC", field: "TowerLocalizationAreaCode", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "TowerLocalizationAreaCode"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 70 },
                    { headerName: "Tower ID", field: "TowerBaseStationID", enableRowGroup: true, sortable: true, filter: true, resizable: true, cellClass: 'bigInt', valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "TowerBaseStationID"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 130 },
                    { headerName: "Cell gen", field: "CellNetGeneration", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "CellNetGeneration"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 80 },
                    { headerName: "Cell signal", field: "RSSI", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, filterParams: { valueGetter: params => { return Formatters.RSSITypeFormatterFilter(params); } }, valueGetter: (params) => { return Formatters.RSSISorting(params); }, cellRenderer: ReeferCellRenderer.RSSITypeFormatter, width: 80 },

                    //{ headerName: "Region Fence ID", field: "RegionGeofence", cellRenderer: Formatters.stringTypeFormatter, width: 150 },

                    //{ headerName: "Device pwr source", field: "RCDPowerSourceCd", cellRenderer: Formatters.rcdPowerSourceFormatter, width: 120 },                    

                ]
                //},
                //{
                //    headerName: 'Device Sensor',
                //    children: [
                //        { headerName: "Temp Sup. 1 ", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, headerValueGetter: Formatters.TempHeaderFormatter, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "SensorSupplyTemp1"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "SensorSupplyTemp1", width: 120 },
                //        { headerName: "Temp Rtn. 1 ", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, headerValueGetter: Formatters.TempHeaderFormatter, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "SensorReturnTemp1"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "SensorReturnTemp1", width: 120 }
                //    ]
            },
        ];
    }

    pageSizeChange(event: React.FormEvent<HTMLSelectElement>) {
        var pageSize = this.state.pageSize;
        var Value: string = event.currentTarget.value;
        pageSize = Value;
        self.setState({
            pageSize: pageSize
        });

        self.state.gridApiParams.paginationSetPageSize(parseInt(pageSize));
        self.state.gridApiParams.paginationGoToFirstPage();
    }

    onGridSelectionChanged(params: any) {
        $("#contextmenu").show();
        var selectedReeferData = [];
        isMapEnable = self.props.mapEnabled;        
        var selectedRows = params.api.getSelectedRows();      

        if (selectedRows != null && selectedRows != undefined) {
            selectedRows.forEach(function (selectedRow, index) {
                selectedReeferData.push(selectedRow);
            });
            var isGraphEnable = self.props.graphEnabled; // WI 26553
            if (isGraphEnable)
                ReeferTemperatureGraph.HighLightGraphData(selectedRows);
            if (isMapEnable) {
                ReeferMap.UpdateIsLocationEstimated(false);
                self.BindMapPushPin(selectedRows);
            }

            self.setState({
                selectedDataItems: selectedRows
            });
        }      

        self.setState({
            selectedItems: selectedReeferData,
            popUpHtml: '',
            modelTitle: ''
        });
        
    }

    BindMapPushPin(selectedRows: any) {        
        var selectedRowsWithCoords = lodashfilter(selectedRows, function (item) {
            return item.GPSCoords != null && item.GPSCoords != undefined && item.GPSCoords.toString() != "";
        });
        //26535 - All occurences of DisplaySelectedPushpin below replaced with DisplaySelectedPushpinByPassingFormatter
        if (selectedRowsWithCoords != null && selectedRowsWithCoords.length > 0)
            ReeferCallout.DisplaySelectedPushpinByPassingFormatter(selectedRowsWithCoords[0], self.state.reeferFormatter);
        else {
            if (self.state.rowData != null && self.state.rowData != undefined && self.state.rowData.length > 0) {
                var selectedRowIndex = self.state.rowData.findIndex(row => row.ParentEventID === selectedRows[0].ParentEventID);
                if (selectedRowIndex != -1) {
                    if (selectedRowIndex == self.state.rowData.length - 1) {
                        ReeferCallout.DisplaySelectedPushpinByPassingFormatter(selectedRows[0], self.state.reeferFormatter);
                    }
                    else {
                        for (var rowIndex = selectedRowIndex + 1; rowIndex < self.state.rowData.length; rowIndex++) {
                            var rowCurrentData = self.state.rowData[rowIndex];
                            if (rowCurrentData.GPSCoords != null && rowCurrentData.GPSCoords != undefined && rowCurrentData.GPSCoords.toString() != "") {
                                ReeferMap.UpdateIsLocationEstimated(true);
                                selectedRows[0].GPSLatitude = rowCurrentData.GPSLatitude;
                                selectedRows[0].GPSLongitude = rowCurrentData.GPSLongitude;
                                ReeferCallout.DisplaySelectedPushpinByPassingFormatter(selectedRows[0], self.state.reeferFormatter);
                                break;
                            }
                            else if (rowIndex == self.state.rowData.length - 1) {
                                ReeferCallout.DisplaySelectedPushpinByPassingFormatter(selectedRows[0], self.state.reeferFormatter);
                            }
                        }
                    }
                }
            }
        }
    }

    onPaginationPageLoaded(params: any) {
        var currentpage = params.api.paginationGetCurrentPage();
        var pagesize = params.api.paginationGetPageSize();
        var rowindex = pagesize * currentpage - 1;

        var rowNode = params.api.getRowNode(rowindex + 1);
        // do something with the row, eg select it
        if (rowNode != undefined && rowNode != null)
            rowNode.setSelected(true);
    }

    navigateToNextCell(params: any) {
        var previousCell = params.previousCellDef;
        var suggestedNextCell = params.nextCellDef;

        var KEY_UP = 38;
        var KEY_DOWN = 40;
        var KEY_LEFT = 37;
        var KEY_RIGHT = 39;

        switch (params.key) {
            case KEY_DOWN:
                previousCell = params.previousCellDef;
                // set selected cell on current cell + 1
                self.state.gridApiParams.gridOptionsWrapper.gridOptions.api.forEachNode((node) => {
                    if (previousCell.rowIndex + 1 === node.rowIndex) {
                        node.setSelected(true);
                    }
                });
                return suggestedNextCell;
            case KEY_UP:
                previousCell = params.previousCellDef;
                // set selected cell on current cell - 1
                self.state.gridApiParams.gridOptionsWrapper.gridOptions.api.forEachNode((node) => {
                    if (previousCell.rowIndex - 1 === node.rowIndex) {
                        node.setSelected(true);
                    }
                });
                return suggestedNextCell;
            case KEY_LEFT:
            case KEY_RIGHT:
                return suggestedNextCell;
            default:
                throw "this will never happen, navigation is always on of the 4 keys above";
        }
    }

    ValidateHistoryDates(filters: any) {
        var currentUtcDttm = moment(new Date(new Date().toUTCString()).toISOString(), 'YYYY-MM-DDTHH:mm:ss');
        var currentDttm = Formatters.DateTimeFormatter(currentUtcDttm);
        this.setState({ PreferenceDTTM: currentDttm });
       // var currentDttm = this.state.PreferenceDTTM;
        var fromDttm = filters.FromDate;
        var toDttm = filters.ToDate;
        if (fromDttm == "Invalid date" || fromDttm == null || fromDttm == "")
            return "Invalid From Date.";

        if (toDttm == "Invalid date" || toDttm == null || toDttm == "")
            return "Invalid To Date.";

        if (moment(new Date(fromDttm)) > moment(new Date(currentDttm)).endOf('day'))
            return "From date should not be greater than current date.";

        if (moment(new Date(toDttm)) > moment(new Date(currentDttm)).endOf('day'))
            return "To date should not be greater than current date.";

        if (moment(new Date(fromDttm)) > moment(new Date(toDttm)))
            return "From Date should not be greater than To Date.";

        return "";
    }

    getReeferHistoryDetails() {
        isMapEnable = this.props.mapEnabled;
        var filters = this.state.Filters;
        var message = this.ValidateHistoryDates(filters);
        if (message != "") {
            PopupWindow.showErrorMessage("Alert", message);
            return;
        }
        else {
            this.setState({ Filters: filters });
        }

        self.state.gridApiParams.showLoadingOverlay();
        var fromDate = moment(new Date(filters.FromDate)).toString();
        var toDate = moment(new Date(filters.ToDate)).toString();
        filters.FromDate = DateFormat(new Date(fromDate), 'mm/dd/yyyy HH:MM');
        filters.ToDate = DateFormat(new Date(toDate), 'mm/dd/yyyy HH:MM');
        var filterParams = JSON.stringify(filters);
        if (this.state.reeferFormatter === null) {
            var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/common/GetReeferFormattersList', { method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json() as Promise<server.ReeferFormatter>)
                .then(data => {
                    this.setState({
                        reeferFormatter: data
                    }, () => {
                        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferhistory/ReeferHistoryDataSP', { method: 'POST', body: filterParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
                        fetch(request)
                            .then(RCUtils.handleError)
                            .then(response => response.json() as Promise<ReeferUnitHistoryUI[]>)
                            .then(data => {
                                this.setState({
                                    rowData: data
                                });

                                self.updateGraphData(data);

                                if (data.length > 0 && isMapEnable) {                                    
                                    ReeferCallout.BindTracePushpins(data, 'trace');
                                    var dataArray = [];
                                    if (self.state.selectedDataItems != null && self.state.selectedDataItems != undefined && self.state.selectedDataItems.length > 0)
                                        dataArray.push(self.state.selectedDataItems[0]);
                                    else
                                        dataArray.push(data[0]);
                                    self.BindMapPushPin(dataArray);
                                }
                                else
                                    $('#globalLoader').hide();
                              
                                self.state.gridApiParams.hideOverlay();
                            });
                    });
                });
        } else {
            var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferhistory/ReeferHistoryDataSP', { method: 'POST', body: filterParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json() as Promise<ReeferUnitHistoryUI[]>)
                .then(data => {
                    this.setState({
                        rowData: data
                    });

                    self.updateGraphData(data);

                    if (data.length > 0 && isMapEnable) {
                        ReeferCallout.BindTracePushpins(data, 'trace');
                        var dataArray = [];
                        if (self.state.selectedDataItems != null && self.state.selectedDataItems != undefined && self.state.selectedDataItems.length > 0)
                            dataArray.push(self.state.selectedDataItems[0]);
                        else
                            dataArray.push(data[0]);
                        self.BindMapPushPin(dataArray);
                    }
                    else
                        $('#globalLoader').hide();
                   
                    self.state.gridApiParams.hideOverlay();
                });
        }
    }

    FromDateChange(date) {
        var filters = self.state.Filters;
        filters.FromDate = DateFormat(new Date(date), 'mm/dd/yyyy HH:MM');
        self.setState({ Filters: filters, buttonState: true });
        //$('#btnReeferHistorySearch').removeAttr('disabled');
    }

    ToDateChange(date) {
        var filters = self.state.Filters;
        filters.ToDate = DateFormat(new Date(date), 'mm/dd/yyyy HH:MM');
        self.setState({ Filters: filters, buttonState: true });
        //$('#btnReeferHistorySearch').removeAttr('disabled');
    }

    renderDateFields() {
        var currentDateFilters = this.state.Filters;
        if (currentDateFilters.ToDate != null && currentDateFilters.ToDate != undefined) {
            var currenttoDTTM = this.state.PreferenceDTTM;
            var toDTTM = DateFormat(new Date(currentDateFilters.ToDate), 'mm/dd/yyyy');
            var fromDTTM = DateFormat(new Date(currentDateFilters.FromDate), 'mm/dd/yyyy');
            var fromDate = moment(new Date(fromDTTM)).startOf('day').toString();
            var toDate = moment(new Date(currenttoDTTM)).endOf('day').toString();
            currentDateFilters.FromDate = DateFormat(new Date(fromDate), 'mm/dd/yyyy HH:MM');
            currentDateFilters.ToDate = DateFormat(new Date(toDate), 'mm/dd/yyyy HH:MM');
            this.setState({ Filters: currentDateFilters });
        }
        else {
            var toDTTM = this.state.PreferenceDTTM;
            var modifiedDttm = new Date(toDTTM);
            modifiedDttm.setDate(modifiedDttm.getDate() - 1);
            var fromDTTM = DateFormat(new Date(modifiedDttm.toString()), 'mm/dd/yyyy');
            var fromDate = moment(new Date(fromDTTM)).startOf('day').toString();
            var toDate = moment(new Date(toDTTM)).endOf('day').toString();
            currentDateFilters.FromDate = DateFormat(new Date(fromDate), 'mm/dd/yyyy HH:MM');
            currentDateFilters.ToDate = DateFormat(new Date(toDate), 'mm/dd/yyyy HH:MM');
            this.setState({ Filters: currentDateFilters });
        }
    }

    renderEmailDialog(gridData: any, colDefs: any, colDefs2: any, formName: string, parentChild: string, functionId: any, widgetId: any, gridApiParams: any, isIncludeRowGroup: boolean, sensorData:any) {
        this.props.renderDataToEmailControl(gridData, colDefs, colDefs2, formName, parentChild, functionId, widgetId, gridApiParams, isIncludeRowGroup, reeferAssetSensors);
    }

    onGridScroll(params: any) {
        $(".context-menu").hide();
        $("#contextmenu").hide();
    }

    openTemperatureGraph() {
        if (this.state.rowData.length > 0)
            this.props.openReeferTemperatureGraph(this.state.rowData, this.state.reeferFormatter, this.state.Filters);
        else
            PopupWindow.showErrorMessage("Alert", "No data to draw graph");
    }

    renderGridPreferenceDialog(functionId: any, widgetId: any, gridApiParams: any, formName: string) {
        this.props.renderDataGridPreferenceControl(functionId, widgetId, gridApiParams, formName);
    }

    renderExportToExcelDialog(functionId: any, widgetId: any, gridApiParams: any, formName: string, gridData: any, colDefs: any, colDefs2: any, parentchild: any, sensorData:any) {
        this.props.renderDataGridExportToExcelControl(functionId, widgetId, gridApiParams, formName, gridData, colDefs, colDefs2, parentchild, reeferAssetSensors);
    }

    //renderSearchButton(isClickEnable: boolean) {
    //    if (isClickEnable)
    //        return <button id="btnReeferHistorySearch" type='button' onClick={this.getReeferHistoryDetails.bind(this)} className='btn btn-primary'>Search</button>;
    //    else
    //        return <button id="btnReeferHistorySearch" type='button' className='btn btn-primary'>Search</button>;
    //}

    onFirstDataRendered(params) {
        var rowGroupItems = [];
        var url = Config.ApiBaseUrl + '/api/User/UserPreference?FunctionId=' + functionId;
        var request = RCUtils.FetchRequest(url);
        var gridPreferencesData: any;
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<any>)
            .then(data => {
                if (data.PreferenceData != null) {
                    var preferenceData = JSON.parse(data.PreferenceData);
                    rowGroupItems = preferenceData.SelectedRowGroups
                    if (rowGroupItems != null && rowGroupItems != undefined && rowGroupItems.length > 0) {
                        self.state.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setRowGroupColumns(rowGroupItems);
                    }
                    if (preferenceData.colState != null && preferenceData.colState != undefined && preferenceData.colState.length > 0) {
                        //self.state.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnState(preferenceData.colState);
                        self.state.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.applyColumnState({ state: preferenceData.colState, applyOrder: false, });
                        //self.state.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.applyColumnState(preferenceData.colState);
                    }

                }
                // RCNG 5198 - OMP - UI:The selected grid columns are not displayed for Export excel and send Email
                if (self.props != null && self.props.dashboardWidgetsSearch != null && self.props.dashboardWidgetsSearch != undefined) {
                    gridPreferencesData = self.props.dashboardWidgetsSearch.filter(x => x.WidgetName =='Reefer History');
                }
                setTimeout(() => {
                    GridColumnPreferences.HistoryGridPreferenceColumns(functionId, params.api, gridPreferencesData, "ReeferMapGrid");

                }, 2000);
            });
    }
    onSavecolumnorder(params) {
        if (!params.columnApi) return;
        var currentGropup = params.columnApi.getRowGroupColumns().map(c => c.colId);
        var colState = params.columnApi.getColumnState();
        var ColumnValues = params.columnApi.getColumnState().map(col => col.colId);
        var selectedColumnIds = [];
        var selectedColumnValues = [];
        var rowGroupItems = [];
        var url = Config.ApiBaseUrl + '/api/User/GetCustomerInterfaceExportColumns?FunctionId=' + functionId;
        var request = RCUtils.FetchRequest(url);
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<any>)
            .then(data => {
                if (data != null) {
                    rowGroupItems = currentGropup;
                    $.each(ColumnValues, function (index, value) {
                        var dataresult = data.filter(x => x.ColumnNm.trim().toUpperCase() == value.trim().toUpperCase());
                        if (dataresult.length > 0) {
                            selectedColumnIds.push(dataresult[0].InterfaceExportColumnId);
                            selectedColumnValues.push(dataresult[0].ColumnNm);
                        }
                    });
                    var url = Config.ApiBaseUrl + '/api/User/SaveUserPreference';
                    var dataToSave = { SelectedColumnIds: selectedColumnIds, SelectedColumnValues: selectedColumnValues, colState: colState, SelectedRowGroups: rowGroupItems };
                    var preferencedata = { UserId: 0, FunctionId: functionId, PreferenceData: JSON.stringify(dataToSave) };
                    var request = RCUtils.FetchRequest(url, { method: 'POST', body: JSON.stringify(preferencedata), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
                    fetch(request)
                        .then(RCUtils.handleError)
                        .then(response => response.json())
                        .then(data => {
                            // save the row group data in background
                        });
                }
            });
    }
    onSaveGridRowGroupState(params) {
        if (!params.columnApi) return;
        var currentGropup = params.columnApi.getRowGroupColumns().map(c => c.colId);
        var colState = params.columnApi.getColumnState();
        var selectedColumnIds = [];
        var selectedColumnValues = [];
        var rowGroupItems = [];
        var url = Config.ApiBaseUrl + '/api/User/UserPreference?FunctionId=' + functionId;
        var request = RCUtils.FetchRequest(url);
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<any>)
            .then(data => {
                if (data.PreferenceData != null) {
                    var preferenceData = JSON.parse(data.PreferenceData);
                    rowGroupItems = currentGropup;
                    selectedColumnIds = preferenceData.SelectedColumnIds;
                    selectedColumnValues = preferenceData.SelectedColumnValues;
                    var url = Config.ApiBaseUrl + '/api/User/SaveUserPreference';
                    var dataToSave = { SelectedColumnIds: selectedColumnIds, SelectedColumnValues: selectedColumnValues, colState: colState, SelectedRowGroups: rowGroupItems };
                    var preferencedata = { UserId: 0, FunctionId: functionId, PreferenceData: JSON.stringify(dataToSave) };
                    var request = RCUtils.FetchRequest(url, { method: 'POST', body: JSON.stringify(preferencedata), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
                    fetch(request)
                        .then(RCUtils.handleError)
                        .then(response => response.json())
                        .then(data => {
                            // save the row group data in background
                        });
                }
                else {
                    // if no userpreference record in db 
                    rowGroupItems = currentGropup;
                    var url = Config.ApiBaseUrl + '/api/User/SaveUserPreference';
                    // var dataToSave = { SelectedColumnIds: selectedColumnIds, SelectedColumnValues: selectedColumnValues, SelectedRowGroups: rowGroupItems };
                    var rowGroupDataToSave = { colState: colState, SelectedRowGroups: rowGroupItems };
                    var preferencedata = { UserId: 0, FunctionId: functionId, PreferenceData: JSON.stringify(rowGroupDataToSave) };
                    var request = RCUtils.FetchRequest(url, { method: 'POST', body: JSON.stringify(preferencedata), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
                    fetch(request)
                        .then(RCUtils.handleError)
                        .then(response => response.json())
                        .then(data => {
                            // save the row group data in background
                        });

                }
            });
        
        //var maxRowGroupLimit = 4;
        //var current = params.columns.length;

        //if (current === maxRowGroupLimit) {
        
        //    groupingDisabled = true;
        //    PopupWindow.showErrorMessage("RowGroup!", "max limit reached, please remove a group before adding a new one");
        
        //    let colDefs = [];
        //    let cols = params.columnApi.getAllColumns();
        //    cols.forEach(col => {
        //        let newColDef = { ...col.colDef, enableRowGroup: false };
        //        colDefs.push(newColDef);
        //    });
        //    params.api.setColumnDefs(colDefs);
        //}
        //if (current < maxRowGroupLimit && groupingDisabled) {
        //    let colDefs = [];
        //    let cols = params.columnApi.getAllColumns();
        //    cols.forEach(col => {
        //        let newColDef = { ...col.colDef, enableRowGroup: true };
        //        colDefs.push(newColDef);
        //    });
        //    params.api.setColumnDefs(colDefs);
        //}
    }

    groupRowInnerRenderer(params) {
        // self.clearGridRowSelection(params);        
        var fieldName = params.node.field;
        var fieldValue = params.node.key;
        //var colDef = params.node.columnApi.columnController.filter(x => x.colId == fieldName);
        var columnDisplayName = params.node.rowGroupColumn.colDef.headerName;//WI 26719

        if (fieldValue.toString().trim() == "-999" && fieldName.toString().trim() == "BatteryVoltage")
            return "*No " + columnDisplayName;
        if (fieldValue.toString().trim() == "-999" && fieldName.toString().trim() == "DoorSensorBatteryVoltage")
            return "*No " + columnDisplayName;
        if (fieldValue.toString().trim() == "-999" && fieldName.toString().trim() != "TripWiseExpiration" && fieldName.toString().trim() != "HumiditySetpoint" && fieldName.toString().trim() !="LineFrequency") // RCNG-169
            return "OOR";
        if (fieldValue == "-NA-" || fieldValue == "null")
            return "*No " + columnDisplayName;

        //if (fieldValue.toString().trim() == "-999" && fieldName.toString().trim() != "HumiditySetpoint" )
        //    return "OOR";

        //if (fieldName.toString() == "EventDTTM" || fieldName.toString() == "UnitEventDTTM" || fieldName.toString() == "PTRDateTime" || fieldName.toString() == "DataLoggerDtm" || fieldName.toString() == "ModifiedDTTM")
        //    return Formatters.dateTypeFormatterGrouping(fieldValue);

        switch (fieldName.toString().trim()) {
            case "RunState":
                return ReeferCellRenderer.RunStateFormatterGrouping(fieldValue);
            case "AssetState":
                return ReeferCellRenderer.AssetStateFormatterGrouping(fieldValue);//added Asset State
            case "MASeverityLevel":
                return ReeferCellRenderer.StatusIndicatorALMFormatterGrouping(fieldValue);
            case "DevicePowerSourceCd":
                return ReeferCellRenderer.PowerStateFormatterGrouping(fieldValue);
            case "CCSeverityLevel":
                return ReeferCellRenderer.CargoCareFormatterGrouping(fieldValue);
            case "VesselCd":
                return fieldValue == "-NA-" ? "No VSL" : fieldValue;
            case "TripStatusCdAndDFlag":
                return ReeferCellRenderer.TripStatusFormatterGrouping(fieldValue);
            case "CustomerName":
                return fieldValue == JSON.parse(sessionStorage.getItem('customerDetails')).CustomerName ? "*No Assigned To" : fieldValue;
            case "ReeferOEMTypeCd":
                return Formatters.OEMTypeFormatterGrouping(fieldValue);
            case "RSSI":
                return ReeferCellRenderer.RSSIFormatterGrouping(fieldValue);
            case "PTIState":
                return (fieldValue == "" || fieldValue == null) ? '-NA-' : fieldValue;
            case "DeviceConfig":
                return Formatters.GuestReeferModeGrouping(fieldValue);
            case "CommentExists":
                return ReeferCellRenderer.CommentExistsGrouping(fieldValue);
            case "PTResult":
                return ReeferCellRenderer.PTResultGrouping(fieldValue);
            /* RCNG 108 start*/
            case "AlarmsList":
                {
                    var DeviceType;
                    if (params.node.rowIndex != undefined && params.node.rowIndex != null
                        && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != undefined
                        && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != null) {
                        DeviceType = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].DeviceType;
                    }
                    return ReeferCellRenderer.AlarmDescriptionGroupingFormatter(fieldValue, DeviceType, self.state.reeferFormatter.AlarmMasterList);
                }
            /* RCNG 108 end*/
            //case "Humidity":
            //    return Formatters.HumidityGrouping(params);
            //case "CondenserPressure":
            //    return Formatters.sensorDataPCondGrouping(params);
            //case "EvaporatorExpansionValveOpening":
            //    return Formatters.sensorDataOpenExpGrouping(params);
            //case "SuctionModulationValveOpening":
            //    return Formatters.sensorDataOpenSucGrouping(params);
            //case "ControlledAtmosphereMode":
            //    return Formatters.ControlledAtmosphereModeGrouping(params);
            case "TripWiseExpiration": // RCNG-169
                return Formatters.TripWiseExpirationGrouping(fieldValue);

            case "DimiRemainTerm":
                return Formatters.DimiRemainTermGrouping(fieldValue);
            case "DimiTerm":
                return Formatters.DimiTermTermGrouping(fieldValue);
            case "CTDuration": // RCNG-1819
                return Formatters.CTDurationGrouping(params);
            case "CTRemainingTime": // RCNG-1819
                return Formatters.CTRemainingTimeGrouping(params);
            //case "RunningMode":
            //    return Formatters.RunningModeGrouping(fieldValue);
            case "Cargo4Temp":
            case "USDA3Temp":
            case "USDA2Temp":
            case "USDA1Temp":
            case "SetPoint":
            case "SupplyTemp1":
            case "SupplyTemp2":
            case "ReturnTemp1":
            case "AmbientTemp":
            case "ReturnTemp2":
            case "EvaporatorTemp":
            case "CompressorSuctionTemp":
            case "CompressorDischargeTemp":
            case "EvaporatorInletSensor": 
            case "EvaporatorOutletSensor":
            case "CompressorDischargeTemp2":
            case "EconomizerInTemp": 
            case "EconomizerOutTemp":
            case "CondenserTemperature":
            case "DeviceTemp":
            case "SensorReturnTemp1":
            case "SensorSupplyTemp1":
            case "CTTempLimit"://RCNG-1819
            case "CTPostSetPoint"://RCNG-1819
                {
                    var DeviceType;
                    if (params.node.rowIndex != undefined && params.node.rowIndex != null
                        && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != undefined
                        && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != null) {
                        DeviceType = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].DeviceType;
                    }
                    return Formatters.TemperatureFormatterGrouping(fieldValue, fieldName, params, DeviceType);
                }
            
            case "TemperatureUnit":
                return Formatters.BookingTemperatureFormatterGrouping(fieldValue, fieldName, params);
            case "EventDTTM":
            case "UnitEventDTTM":
            case "PTRDateTime":
            case "DataLoggerDtm":
            case "ModifiedDTTM":
            case "DLEventDTTM":
            case "DoorEventDtm":
            case "TripStart":
            case "TripEnd":
            case "CTTime":
                return Formatters.dateTypeGrouping(fieldValue, fieldName, params);
            case "GPSCoords":
                return Formatters.GPSCoordsFormatterGrouping(fieldValue, params);
            case "HumiditySetpoint":
                {
                    var HumiditySetpointStatus;
                    if (params.node.rowIndex != undefined && params.node.rowIndex != null
                        && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != undefined
                        && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != null) {
                        HumiditySetpointStatus = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].HumiditySetpointStatus;
                    }
                    return Formatters.HumiditySetpointGrouping(fieldValue, HumiditySetpointStatus);
                }
              case "TripWiseStatusDescription":
                {
                    var ReeferOEMTypeCd; var DimiResultActuator; var DimiResultAlarm; var DimiResultOOR; var DimiResultTerm;
                    if (params.node.rowIndex != undefined && params.node.rowIndex != null
                        && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != undefined
                        && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != null) {
                        ReeferOEMTypeCd = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].ReeferOEMTypeCd;
                        DimiResultActuator = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].DimiResultActuator;
                        DimiResultAlarm = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].DimiResultAlarm;
                        DimiResultOOR = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].DimiResultOOR;
                        DimiResultTerm = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].DimiResultTerm;
                    }
                return ReeferCellRenderer.TripWiseStatusGrouping(fieldValue,ReeferOEMTypeCd,DimiResultActuator,DimiResultAlarm,DimiResultOOR,DimiResultTerm);
                }
            case "DoorOpen":
                return ReeferFormatters.DoorFormatterGrouping(fieldValue);//RCNG-1106
            case "EverFRESH":
                return Formatters.EverFreshFormatterGrouping(fieldValue);
            case 'DimiStartAfter':
                return Formatters.OEMPTITypeFormatter(fieldValue);
            case 'ReeferBatteryPct':
                return ReeferCellRenderer.ReeferDoorBattPctFormatterGrouping(fieldValue);
            default:
                return fieldValue;

        }
    }

    getMainMenuItems(params) {
        let finalMenuItem = [];
        let itemsToExclude = "resetColumns";
        params.defaultItems.forEach(function(item) {
            if (itemsToExclude.indexOf(item) < 0) {
                finalMenuItem.push(item);
            }
        });
        finalMenuItem.push({
            name: 'Reset Columns',
            action: function() {
                self.setState({ gridApiParams: params.api });
                var defaultColumns = params.api.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
                params.api.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultColumns, false);
                GridColumnPreferences.ResetGridColumns(functionId, params.api, "ReeferHistoryGrid");
            },
        });
        return finalMenuItem;
    }

    onColumnResized = (params: any) => {
        //console.log("column resized..");
        self.onSaveGridRowGroupState(params);
    }


    public render() {
        var groupRowRendererParams: any = {
            innerRenderer: this.groupRowInnerRenderer
        };
        var excelStyles: any = [
            {
                id: 'bigInt',
                dataType: 'string',
                font: {
                    size: 12
                },

            },
            {
                id: 'myExcelStyle',
                font: {
                    size: 12,
                }
            },
            {
                id: 'OneDecimal',
                numberFormat: {
                    format: '0.0',
                },
                font: {
                    size: 12,
                }
            },
            {
                id: 'TwoDecimal',
                numberFormat: {
                    format: '0.00',
                },
                font: {
                    size: 12,
                }
            },
            {
                id: 'header',
                font: {
                    size: 14,
                },
            },
        ];
        return <div>
            <div className='dashboard-GridToolbar'>
                <GridReeferHistoryToolBar
                    refreshGrid={this.refreshGrid.bind(this,false)}
                    gridData={this.state.rowData}
                    gridApiParams={this.state.gridApiParams}
                    colDefs={this.state.columnDefs}
                    colDefs2={columnDefs2}
                    parentchild={"C"}
                    formName={"ReeferHistoryGrid"}
                    searchFilters={this.state.Filters}
                    getReeferHistoryDetails={this.getReeferHistoryDetails.bind(this)}
                    sourceFrom='Dashboard'
                    sensorData={reeferAssetSensors}
                    dashboardPreferenceId = {this.props.dashboardPreferenceId}
                    isReadOnly={this.props.isReadOnly}
                    revisionNum={this.props.revisionNum}
                    dashboardWidgetsSearch={this.props.dashboardWidgetsSearch}
                    validateRevisionNum={this.props.validateRevisionNum.bind(this)}
                    renderEmailDialog={this.renderEmailDialog.bind(this)}
                    openTemperatureGraph={this.openTemperatureGraph.bind(this)}
                    renderGridPreferenceDialog={this.renderGridPreferenceDialog.bind(this)}
                    renderExportToExcelDialog={this.renderExportToExcelDialog.bind(this)}
                />
            </div>

            <div className="widget-calender">

                <div className="input-group from-to-calender">
                    <span className="input-group-text">From</span>
                    <DatePicker
                        selected={new Date(this.state.Filters.FromDate)}
                        maxDate={new Date(this.state.PreferenceDTTM)}
                        onChange={this.FromDateChange.bind(this)}
                        timeInputLabel="Time:"
                        showYearDropdown
                        yearDropdownItemNumber={5}
                        dateFormat="MM/dd/yyyy hh:mm aa"
                        showTimeInput  
                        className=""                          
                    />
                    <span className="input-group-text">To</span>
                    <DatePicker
                        selected={new Date(this.state.Filters.ToDate)}
                        maxDate={new Date(this.state.PreferenceDTTM)}
                        onChange={this.ToDateChange.bind(this)}
                        timeInputLabel="Time:"
                        showYearDropdown
                        yearDropdownItemNumber={5}
                        dateFormat="MM/dd/yyyy hh:mm aa"
                        showTimeInput
                        className=""    
                    />

                    {
                        this.state.buttonState == true ?
                            <button type='button' onClick={this.getReeferHistoryDetails.bind(this)} className='btn btn-primary'>Search</button>
                            :
                            <button type='button' disabled={this.state.buttonState == false} className='btn btn-primary'>Search</button>
                    }

                </div>

            </div>

            


            <div className="ag-theme-fresh Dashboard-ReeferHistoryGrid-height">
                <AgGridReact
                    columnDefs={this.state.columnDefs}
                    rowData={this.state.rowData}
                    onGridReady={this.onGridReady}
                    animateRows={true}
                    rowGroupPanelShow={this.state.rowGroupPanelShow}
                    autoGroupColumnDef={this.state.autoGroupColumnDef}
                    suppressDragLeaveHidesColumns={true}
                    suppressMakeColumnVisibleAfterUnGroup={true} 
                    onFirstDataRendered={this.onFirstDataRendered.bind(this)}
                    processCellForClipboard={this.ProcessCellForClipboard}
                    enableRangeSelection={true}
                    onColumnRowGroupChanged={this.onSaveGridRowGroupState.bind(this)}
                    onDragStopped={this.onSavecolumnorder.bind(this)}
                    onColumnPinned={this.onSaveGridRowGroupState.bind(this)}
                    onColumnResized={Formatters.debounce(this.onColumnResized, 1000)}
                    groupRowRendererParams={groupRowRendererParams}
                    getMainMenuItems={this.getMainMenuItems.bind(this)}
                    //groupRowInnerRenderer={this.groupRowInnerRenderer}
                    defaultGroupOrderComparator={
                        function (nodeA, nodeB) {
                            var AnodeIsNumber = Number(nodeA.key);
                            var BnodeIsNumber = Number(nodeB.key);
                            var AnodeIsString = String(nodeA.key);
                            var BnodeIsString = String(nodeB.key);

                            if (!isNaN(AnodeIsNumber) && !isNaN(BnodeIsNumber)) {
                                return AnodeIsNumber - BnodeIsNumber;
                            } else {
                                return AnodeIsString.localeCompare(BnodeIsString);
                            }
                        }
                    }
                    allowContextMenuWithControlKey={true}
                    groupDisplayType='groupRows'
                    pagination={true}
                    paginationPageSize={this.state.pageSize}
                    rowSelection={'multiple'}
                    accentedSort={true}
                    excelStyles={excelStyles}
                    getContextMenuItems={this.getReeferHistoryContextMenuItems}
                    rowDeselection={true}
                    onSelectionChanged={this.onGridSelectionChanged}
                    onPaginationChanged={this.onPaginationPageLoaded}
                    navigateToNextCell={this.navigateToNextCell}
                    tooltipShowDelay={0}
                    tooltipHideDelay={8000}
                    frameworkComponents={this.state.frameworkComponents}
                    overlayLoadingTemplate={this.state.overlayLoadingTemplate}
                    onBodyScroll={this.onGridScroll}>
                </AgGridReact>
            </div>
            <div className='pageSize'>
                <span className='pageSize-lable'>Page Size:</span>
                <select onChange={e => this.pageSizeChange(e)} value={this.state.pageSize}>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="75">75</option>
                    <option value="100">100</option>
                    <option value="250">250</option>
                </select>
            </div>
        </div>;
    }
}

class ReeferHistoryFilter {
    FromDate: string;
    ToDate: string;
    Units: string;
}

interface ReeferUnitHistoryUI {
    HighSpeedEvaporatorFanOutPut: string;
    IsAcceptableBatteryVoltage?: boolean;
    BatteryVoltage?: number;
    RCDPowerSourceCd: string;
    ReeferACPowerLevel?: number;
    ReeferOEMTypeCd: string;
    IsReeferPhysicallyConnected?: boolean;
    IsReeferCommunicationEstablished?: boolean;
    ReeferSwitchOn?: boolean;
    DeviceTemp?: number;
    UnitEventID?: number;
    EventMasterID?: number;
    EventDTTM?: Date;
    ModifiedDTTM?: Date;
    U_UnitAlarmSummaryHistoryID?: number;
    UnitControlEventID?: number;
    C_EventDTTM?: Date;
    C_EventMasterID?: number;
    UnitVesselOperationsID?: number;
    UnitCargoCareID?: number;
    C_UnitAlarmSummaryHistoryID?: number;
    Status: string;
    IsOnVessel: boolean;
    IsCargoCare: boolean;
    IsAcceptableACVoltage?: boolean;
    R_RCDStateReportedHistoryID?: number;
    RunState?: number;
    ControlledAtmosphereMode: string;
    R_EventDTTM?: Date;
    TimeToDefrost?: number;
    LineFrequency?: number;
    CurrentPhaseA?: number;
    CurrentPhaseB?: number;
    CurrentPhaseC?: number;
    ThreePhaseCurrent: string;
    ReturnTempLongAvg?: number;
    AmbientTempLongAvg?: number;
    CompositeSuctionPressureLongAvg?: number;
    DischargePressureLongAvg?: number;
    SupplyTemperatureLongAvg?: number;
    ReturnTemperatureLongAvg?: number;
    CompressorSuctionTempLongAvg?: number;
    CompressorCondensorTempLongAvg?: number;
    RCDEventID?: number;
    R_EventMasterID?: number;
    RCDMasterID?: number;
    RCDMasterHistoryID?: number;
    RCDGSMPositionHistoryID?: number;
    RCDLocationHistoryID?: number;
    RCDGPSPositionHistoryID?: number;
    RCDStateReportedHistoryID?: number;
    RCDAlarmSummaryHistoryID?: number;
    CCIsOffpower?: boolean;
    CCIsSetpoint?: boolean;
    CCMissingScheduleCd?: number;
    CCIsTempOutOfRange?: boolean;
    SIM_IMSI: string;
    ICCID: string;
    CompressorEvaporatorTempLongAvg?: number;
    CompressorDischargeTempLongAvg?: number;
    CountryCd: string;
    CountryName: string;
    UnitEventDTTM?: Date;
    UnitMasterID?: number;
    RCDReportingInterval?: number;
    Street: string;
    City: string;
    State: string;
    Zip: string;
    RCDRfrComErr?: boolean;
    TripId?: number;
    TripNm: string;
    TripStatusCd: string;
    TripStatusDescription: string;
    TripNameAndStatus: string;
    TripHistoryId?: number;
    BookedTemperature?: number;
    BookingNumber: string;
    TemperatureUnit: string;
    MSISDN: string;
    DataLoggerDtm?: Date;
    RSSI?: number;
    HotGasValveOpening?: number;
    C_ModifiedDTTM?: Date;
    GeofenceName: string;
    RCDID: string;
    Country: string;
    RCDFirmwareVersion: string;
    RCDBootloaderVersion: string;
    RCDMeshFirmwareVersion: string;
    RevisionNum?: number;
    LineVoltage1?: number;
    LineVoltage2?: number;
    LineVoltage3?: number;
    GPSLatitude?: number;
    GPSLongitude?: number;
    GPSLastLock?: number;
    GPSCoords: string;
    GPSLockState: string;
    IsInsideGeofence?: boolean;
    Geofence: string;
    CustomerAccessGroupIDList: string;
    TowerBaseStationID?: number;
    TowerLocalizationAreaCode?: number;
    MNC?: number;
    SuctionModulationValveOpening?: number;
    EconomizerValveOpening?: number;
    CondenserFanOutPut: string;
    DeviationFlg?: boolean;
    LowSpeedEvaporatorFanOutPut: string;
    CompositeSuctionPressureQualifier?: any;
    PretripTestStateID?: any;
    DefrostInterval: string;
    VentPositionCMHQualifier?: any;
    TotalCurrentDrawQualifier?: any;
    PretripTimeDisplay: string;
    PretripTestNumber?: number;
    PretripSubTestNumber?: number;
    SetPoint?: number;
    O2Setpoint?: number;
    CO2Setpoint?: number;
    HumiditySetpoint?: number;
    CompressorHighSpeed?: number;
    ElectricHeatOutPut?: number;
    MicroVersion: string;
    SoftwareRevision: string;
    AmbientTempQualifier?: any;
    USSH_Cargo4TempQualifier?: any;
    CO2ReadingQualifier?: any;
    CO2SetpointQualifier?: any;
    ColdTreatmentActive?: boolean;
    CompressorDischargeTempQualifier?: any;
    CompressorSuctionTempQualifier?: any;
    DischargePressureQualifier?: any;
    CondenserFanOutputQualifier?: any;
    HumiditySetpointStatus: string;
    O2ReadingSupport: string;
    ParentEventID?: number;
    UnitPrefix: string;
    UnitNumber: string;
    ReeferID: string;
    AlarmsList: string;
    CCAlarms: string;
    CCSeverityLevel: string;
    MicroAlarms: string;
    MASeverityLevel: string;
    UnitUSDAHistoryID?: number;
    USDA1Temp?: number;
    USDA1TempQualifier?: any;
    USDA2Temp?: number;
    USDA2TempQualifier?: any;
    USDA3Temp?: number;
    USDA3TempQualifier?: any;
    Cargo4Temp?: number;
    Cargo4TempQualifier?: any;
    UnitSettingsHistoryID?: number;
    DischargePressure?: number;
    CompositeSuctionPressure?: number;
    VentPositionSensorCMH?: number;
    O2SetpointSupport: string;
    CO2ReadingSupport: string;
    CondenserPressureQualifier?: any;
    DataLoggerDtmQualifier?: any;
    CurrentPhaseCQualifier?: any;
    ControllerSerialNumber: string;
    CompressorFrequency?: number;
    CondenserTemperature?: number;
    CondenserPressure?: number;
    HeaterOnTime?: number;
    EvaporatorExpansionValveOpening?: number;
    RunningMode: string;
    URH_UnitReadingsHistoryID?: number;
    Humidity?: number;
    AmbientTemp?: number;
    CompressorSuctionTemp?: number;
    CompressorDischargeTemp?: number;
    ReturnTemp1?: number;
    SupplyTemp1?: number;
    SupplyTemp2?: number;
    ReturnTemp2?: number;
    EvaporatorTemp?: number;
    NumberOfAlarmsInQue?: number;
    O2Reading?: number;
    CO2Reading?: number;
    OEMAlarmBlock: string;
    ISOFaultBlock: string;
    TotalCurrentDraw?: number;
    SupplyTempQualifier?: any;
    SupplyTemp3Qualifier?: any;
    SupplyTemp2Qualifier?: any;
    SupplyTemp1Qualifier?: any;
    CondenserTempQualifier?: any;
    ControllerSerialNumberQualifier?: any;
    CurrentPhaseAQualifier?: any;
    CurrentPhaseBQualifier?: any;
    DefrostIntervalQualifier?: any;
    EconomizerValveOpeningQualifier?: any;
    EvaporatorExpansionValveOpeningQualifier?: any;
    EvaporatorTempQualifier?: any;
    UnitHardwareVersion: string;
    HeaterOnTimeQualifier?: any;
    HighSpeedEvaporatorFanOutputQualifier?: any;
    TripStatusCdAndDFlag: string;
    HotGasValveOpeningQualifier?: any;
    LowSpeedEvaporatorFanOutputQualifier?: any;
    MicroVersionQualifier?: any;
    O2ReadingQualifier?: any;
    O2SetpointQualifier?: any;
    PowerSupplyDCVoltageQualifier?: any;
    ReturnTemp1Qualifier?: any;
    ReturnTemp2Qualifier?: any;
    ReturnTemp3Qualifier?: any;
    ReturnTempQualifier?: any;
    SetPointQualifier?: any;
    SuctionModulationValveOpeningQualifier?: any;
    LineFrequencyQualifier?: any;
    DeviceConfig?: boolean;
    Sensor1Value: number;
    Sensor2Value: number;
    Sensor3Value: number;
    Sensor4Value: number;
    Sensor5Value: number;
    Sensor6Value: number;
    Sensor7Value: number;
    Sensor8Value: number;
    DeviceType: any;
    ArrivingVVC: string,
    DepartingVVC: string,
    CargoCareCustomerProfileID?: number,
    CCProfileCode: string,
    ColdTreatmentState: string,
    EvaporatorInletSensor: any;
    EvaporatorOutletSensor: any;
	CompressorDischargeTemp2: any;
    AirPumpRunHours: any;
	CARunHours: any;
	CASoftwareRevision: any;
	EconomizerInTemp: any;
	EconomizerOutTemp: any;
	CompressorRunHours: any;
	PowerMeter: any;	
	PTIType: any;
    ControllerTypeCd: any;
    CompressorCurrent: any;
    BulbMode: any;
    EvaporatorFanSpeedControl: any;
    CTTime: any;
}